import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-0" }
const _hoisted_2 = ["disabled"]

import { ref, computed } from "vue";
import { useStore } from "vuex";
import type { Applicant } from "@/models/application";
import type { Stipulation } from "@/models/opal";
import Employers from "@/components/checklist/income-verification/Employers.vue";
import ConfirmManualncomeVerificationModal from "@/components/modals/ConfirmManualncomeVerificationModal.vue";

interface Props {
  stip: Stipulation;
  applicant: Applicant;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AutomatedIncomeVerificationConsent',
  props: {
    stip: {},
    applicant: {}
  },
  setup(__props: any, { expose: __expose }) {

const store = useStore();

const props = __props;

const modalRef = ref<InstanceType<typeof ConfirmManualncomeVerificationModal> | null>();
const employersRef = ref<InstanceType<typeof Employers> | null>();

const manualCertification = ref<boolean>(false);

const measureOneEnabled = computed<boolean>(() => store.state.configuration?.measureOneEnabled);
const loading = computed<boolean>(() => modalRef.value?.loading || false);
const employers = computed(() => (employersRef.value ? employersRef.value?.employers : []));
const employments = computed(() => {
  return employersRef.value ? employersRef.value?.employments : ([] as string[]);
});

async function consent() {
  await modalRef.value?.handleAutomatedIncomeVerificationConsent();
}

function closeModal() {
  modalRef.value?.closeModal();
}

function confirmManualCertification() {
  manualCertification.value = true;
  modalRef.value?.openModal();
}

__expose({
  employers,
  employments,
  employersRef,
  modalRef,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Employers, {
        ref_key: "employersRef",
        ref: employersRef,
        applicant: __props.applicant
      }, null, 8, ["applicant"]),
      (measureOneEnabled.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: _normalizeClass(["btn btn-primary px-16 py-11 flex-grow-1 w-100 my-25", [{ loading: loading.value }]]),
            onClick: consent,
            disabled: loading.value
          }, " Consent ", 10, _hoisted_2))
        : _createCommentVNode("", true)
    ]),
    _createVNode(ConfirmManualncomeVerificationModal, {
      ref_key: "modalRef",
      ref: modalRef,
      stip: __props.stip,
      applicant: __props.applicant,
      employments: employments.value,
      manualCertification: manualCertification.value,
      onClose: closeModal
    }, null, 8, ["stip", "applicant", "employments", "manualCertification"]),
    _createElementVNode("div", { class: "text-center mt-11" }, [
      _createElementVNode("a", {
        class: "text-decoration-underline",
        onClick: confirmManualCertification
      }, "Click here to submit income documents instead")
    ])
  ], 64))
}
}

})